<header class="d-flex flex-column flex-md-row align-items-md-center p-5 title-bg-dark">
  <div class="pt-md-3 pb-md-4">
    <h1 class="bd-title mt-0">About us</h1>
    <p class="bd-lead">Learn about the origin of the raid organizer bot here</p>
  </div>
</header>

<section class="p-5 guild-bg-dark">
  <h2>The Idea</h2>
  <p>
    At the beginning of 2019, <i>wolfsberger#1266</i> began work on the initial version of what would later become the bot known as <i>Raid Organizer</i>. The idea was to build a small bot to help our guild create and plan events via Discord.
  </p>
  <p>
    Since the first (unofficial) version was only used by our guild and <i>wolfsberger#1266</i> had started his master's thesis, I (<i>snawe#8570</i>) took over the project in mid-November 2019.
  <br>On December 23, 2019, the first beta version was released to a small number of servers (~10).
  <br>From there, the bot began to grow—not just in the number of active servers, but also in terms of functionality, options, and customizability.
  <br>Even though <i>wolfsberger#1266</i> is now mostly inactive, I (<i>snawe#8570</i>) continue to update
    the bot regularly, receiving support from many sides to make this possible.
  </p>
  <p>
    After all, <i>Raid Organizer</i> is a bot <u>from</u> MMO players <u>for</u> MMO players!
  </p>
  <p>I want to thank everyone that is helping me on this journey! No matter if via buying premium, suggestions, bug reports, or anything else!</p>
</section>

